// ----------------------------------------------------------------------

const MuiLink = {
  defaultProps: { underline: 'hover' },

  styleOverrides: {},
};

// ----------------------------------------------------------------------

export const link = { MuiLink };
